import { useAppConfigContext } from "@/context/AppConfig";
import { Notes } from "@/reports/sections/NotesSection/Notes/Notes";
import { Button, Input, Stack, styled } from "@/theme/index";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

interface ReportNoteFormProps {
  permalink: string;
}

interface RawReportNote {
  body: string;
}

export const FormContainer = styled("form")`
  width: 100%;
  height: 100%;
`;

export function NoteForm({ permalink }: ReportNoteFormProps) {
  const { trackEventGA4 } = useAppConfigContext();
  const noteInput = useRef<HTMLInputElement | null>(null);
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (newNote: RawReportNote) => {
      return Notes.createNote(permalink, newNote);
    },

    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["reportNotes"] }),
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    trackEventGA4({ event_name: "add note", place: "notes section" });
    const input = noteInput.current?.value;
    if (input) {
      const newNote = { body: input };
      mutation.mutate(newNote);
    }
    if (noteInput.current) noteInput.current.value = "";
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <Input
          type="text"
          placeholder="Add a note here..."
          inputRef={noteInput}
          sx={{ flexGrow: 1 }}
        />
        <Button type="submit" variant="contained" color="success">
          Add a note
        </Button>
      </Stack>
    </FormContainer>
  );
}
